import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { ButtonLegacyModule } from 'studio-components/button-legacy/button-legacy.module';
import { DialogModule } from 'studio-components/dialog/dialog.module';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { DialogDisplayModule } from 'studio-components/dialog/services/dialog-display.module';
import { ConfirmationDialogService } from './services/confirmation-dialog.service';

@NgModule({
  declarations: [ConfirmationDialogComponent],
  providers: [ConfirmationDialogService],
  imports: [CommonModule, MatDialogModule, ButtonLegacyModule, DialogModule, DialogDisplayModule],
  exports: [ConfirmationDialogComponent],
})
export class ConfirmationModule {}
